import {
  CHAT_FORM_FIELD_NAME_PARTICIPANTS,
  CHAT_FORM_INITIAL_VALUES,
} from '../../../../Chat'
import { toUserSelectItem } from '../../../../User'

export function getUserProfilePageChatFormInitialValues(userData) {
  return {
    ...CHAT_FORM_INITIAL_VALUES,
    [CHAT_FORM_FIELD_NAME_PARTICIPANTS]: [toUserSelectItem(userData)],
  }
}
